import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import UserBadge from "@/components/UserBadge";
import { fetchCritics } from "@/lib/api";
import { Loader2, ShieldCheck } from "lucide-react";

export default function CriticsPage() {
  const [critics, setCritics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCritics().then(setCritics).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main className="max-w-5xl mx-auto px-6 py-14" data-testid="critics-page">
        <div className="text-[11px] uppercase tracking-[0.25em] text-amber font-heading mb-2 flex items-center gap-1.5">
          <ShieldCheck className="h-3 w-3" /> Verified critics
        </div>
        <h1 className="font-display text-4xl sm:text-5xl text-white mb-8">Voices to follow</h1>

        {loading ? (
          <div className="py-12 flex justify-center"><Loader2 className="h-8 w-8 animate-spin text-amber" /></div>
        ) : critics.length === 0 ? (
          <p className="text-zinc-500 font-body italic">No verified critics yet. Admins can grant the critic badge from the admin panel.</p>
        ) : (
          <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="critics-list">
            {critics.map((c) => (
              <li key={c.user_id} className="border border-white/10 rounded-md p-5 bg-obsidian-surface/60 hover:border-amber/40 transition" data-testid={`critic-${c.user_id}`}>
                <Link to={`/u/${c.user_id}`} className="flex items-center gap-3">
                  {c.picture ? (
                    <img src={c.picture} alt="" className="h-14 w-14 rounded-full border border-amber/40 object-cover" />
                  ) : (
                    <div className="h-14 w-14 rounded-full bg-amber/20 text-amber font-display flex items-center justify-center text-2xl">{c.name?.[0]}</div>
                  )}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-1.5">
                      <div className="font-display text-lg text-white truncate">{c.name}</div>
                      <UserBadge user={c} />
                    </div>
                    <div className="text-xs text-zinc-500 font-heading">{c.review_count} reviews</div>
                  </div>
                </Link>
                {c.bio && <p className="text-sm text-zinc-400 mt-3 font-body line-clamp-2">{c.bio}</p>}
              </li>
            ))}
          </ul>
        )}
      </main>
    </div>
  );
}
